<template>
  <div>
    <v-container class="content-wrapper" fluid id="favorites-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex">
          <v-btn-toggle v-model="toggleFavorite" rounded mandatory>
            <v-btn value="equipment" class="btn-selected">
              Equipment
            </v-btn>
            <v-btn value="services" class="btn-selected">
              Services
            </v-btn>
            <v-btn value="intellectualProperties" class="btn-selected">
              Intellectual Properties
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Equipment -->
      <v-row v-if="toggleFavorite === 'equipment'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <h2 class="black--text font-weight-bold">
            Equipment
          </h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleFavorite === 'equipment'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <div>
            <MyFavoritesEquipment></MyFavoritesEquipment>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Services -->
      <v-row v-if="toggleFavorite === 'services'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <h2 class="black--text font-weight-bold">
            Services
          </h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleFavorite === 'services'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <div>
            <MarketplaceServicesComponent :my-favorites="true"></MarketplaceServicesComponent>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Patents -->
      <v-row
        justify="start"
        align="center"
        v-if="toggleFavorite == 'intellectualProperties'"
        class="mt-5"
      >
        <v-row id="filtering-toggle">
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" class="justify-center d-flex">
            <v-btn-toggle v-model="toggleIntellectualProperties" rounded mandatory>
              <v-btn value="patents" class="btn-selected">
                Patents
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-row>
      <v-row
        v-if="
          toggleFavorite == 'intellectualProperties' && toggleIntellectualProperties == 'patents'
        "
      >
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <h2 class="black--text font-weight-bold">
            Patents
          </h2>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row
        justify="center"
        align="center"
        v-if="
          toggleFavorite == 'intellectualProperties' && toggleIntellectualProperties == 'patents'
        "
      >
        <v-spacer></v-spacer>
        <v-col cols="12" xl="6" lg="8" md="12" sm="12">
          <div>
            <MyFavoritesPatents :my-favorites="true"></MyFavoritesPatents>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MyFavoritesEquipment from './MyFavoritesEquipment.vue';
import MarketplaceServicesComponent from '@/components/marketplace/MarketplaceResourcesComponent';
import MyFavoritesPatents from './MyFavoritesPatents.vue';
import util from '@/mixins/util';

export default {
  name: 'MyFavorites',
  mixins: [util],
  components: {
    MyFavoritesEquipment,
    MyFavoritesPatents,
    MarketplaceServicesComponent,
  },
  data: () => ({
    toggleFavorite: 'equipment',
    toggleIntellectualProperties: 'patents',
    search: {},
  }),
  watch: {
    '$route.query.toggleOrder'(newValue) {
      if (newValue === 'services') {
        this.toggleFavorite = newValue;
      }
    },
  },
  mounted() {
    if (this.$route.query.toggleOrder) {
      this.toggleFavorite = this.$route.query.toggleOrder;
    }
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
